import React from 'react';
import { Link } from 'react-router-dom'
import { Tab, Tabs } from "@mui/material";
import useRouteMatch from "../../../hooks/useRouteMatch";

export const BasicRouteTabs = () => {
    const currentTab = useRouteMatch([
        '/quick-room'
    ]);

    return (
        <Tabs 
            value={currentTab}
            variant="fullWidth"
            textColor="inherit"
            indicatorColor="secondary"
            sx={{ textColor: '#FFFFFF' }}
        >
            <Tab label="Quick Room" value="/quick-room" to="/quick-room" component={Link} />
        </Tabs>
    )
}